import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ModalsService} from "../../services/modals.service";
import {SubscriberService} from "../../services/subscriber.service";
import {SubscriptionStatus} from "../../model/subscription-status";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-subscription-info-modal',
  templateUrl: './subscription-info-modal.component.html',
  styleUrls: ['./subscription-info-modal.component.css']
})
export class SubscriptionInfoModalComponent implements OnInit, OnDestroy {
  @Input() privetPlus: boolean;

  subscriptionActive: boolean;
  subscriptionStatus: SubscriptionStatus;

  subscription: Subscription;

  constructor(private readonly modalsService: ModalsService,
              private readonly subscriberService: SubscriberService) {
    this.subscriptionStatus = SubscriptionStatus.NO_PROFILE;
    this.subscriptionActive = false;

    this.subscription = new Subscription();
  }

  ngOnInit(): void {
    this.subscription.add(
      this.subscriberService.subscriber.subscribe(subscriber => {
        if (subscriber) {
          this.subscriptionStatus = this.privetPlus ? subscriber.privetPlusStatus : subscriber.privetStatus;
          this.subscriptionActive = this.subscriptionStatus == SubscriptionStatus.ACTIVE || this.subscriptionStatus == SubscriptionStatus.ACTIVATING;
        }
      })
    )
  }

  close(): void {
    this.modalsService.hideModal();
  }

  activateSubscription(): void {
    if (this.subscriptionStatus != SubscriptionStatus.ACTIVE) {
      this.modalsService.showActivateSubscription(this.privetPlus);
    }
  }

  deactivateSubscription(): void {
    if (this.subscriptionStatus == SubscriptionStatus.ACTIVE) {
      this.modalsService.showDeactivateSubscription(this.privetPlus);
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
